import { Component, inject } from '@angular/core';
import { SvgIconComponent } from "../../svg-icon/svg-icon.component";
import { AuthenticatorService } from '../../../core/service/authenticator.service';
import { environment } from '../../../../environments/environment';
import { AsyncPipe } from '@angular/common';
import { DropdownDirective } from '../../dropdown/dropdown.directive';
import { RequireAuthService } from 'src/app/core/service/require-auth.service';
import { FeatureName } from 'src/app/core/model/common';
import { OpenUrlService } from 'src/app/core/service/open-url.service';
import { map } from 'rxjs';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/core/service/account.service';
import { SeparatorComponent } from "../../separator/separator.component";
import { SettingsComponent } from 'src/app/ui/settings/settings.component';
import { ModalService } from 'src/app/ui/modal/modal.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-user-menu',
  imports: [SvgIconComponent, AsyncPipe, DropdownDirective, SeparatorComponent, TranslateModule],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.css'
})
export class UserMenuComponent {

  //protected keycloak = inject(Keycloak)
  protected authenticator = inject(AuthenticatorService)
  private router = inject(Router)
  private account = inject(AccountService)
  private requireAuth = inject(RequireAuthService)
  private openUrl = inject(OpenUrlService)
  private modal = inject(ModalService)
  protected idSystemUrl = environment.idSystem.url + '/account/profile'

  protected accName$ = this.account.user$.pipe(
    map(user => {
      if (user === undefined) return ''
      if (user.email) return this.maskEmail(user.email)
      if (user.telegram?.username) return this.maskName(user.telegram.username)
      if (user.telegramId) return this.maskName(user.telegramId)
      return ''
    }),
  )

  protected usernameFirstCharacter = this.accName$.pipe(map(userName => userName.charAt(0).toUpperCase()))

  protected loginClick() {
    this.authenticator.login()
  }

  protected logoutClick() {
    this.authenticator.logout()
  }

  protected settingsClick() {
    this.modal.create(SettingsComponent)
  }

  protected supportClick() {
    this.requireAuth.registerFeatureUsage(FeatureName.support).subscribe(() => this.openUrl.openUrl('https://t.me/WebCScalp_Support_Bot'))
  }

  protected getSettingsClickHandler() {
    return this.authenticator.isAuthed ? this.settingsClick() : this.loginClick();
  }

  private maskEmail(email: string) {
    const [name, domain] = email.split('@')
    return `${this.maskName(name)}@${domain}`
  }

  private maskName(name: string) {
    return name.slice(0, 1) + '***' + name.slice(-1)
  }
}
